import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Basket, BasketItem, IBasketTotals } from '../shared/models/basket';
import { IDeliveryMethod } from '../shared/models/deliveryMethod';
import { Product } from '../shared/models/product';
import { IDeliveryToCreate } from '../shared/models/deliveryToCreate';

@Injectable({
  providedIn: 'root'
})
export class BasketService {
  baseUrl = environment.apiUrl;
  private basketSource = new BehaviorSubject<Basket | null>(null);
  basketSource$ = this.basketSource.asObservable();
  private basketTotalSource = new BehaviorSubject<IBasketTotals | null>(null);
  basketTotalSource$ = this.basketTotalSource.asObservable();
  
  constructor(private http: HttpClient) { }

  createPaymentIntent() {
    return this.http.post<Basket>(this.baseUrl + 'payments/' + this.getCurrentBasketValue()?.id, {})
    .pipe(
      map(basket => {
        this.basketSource.next(basket);
      })
    )
  }
  
  setShippingPrice(deliveryMethod: IDeliveryMethod) {
    const basket = this.getCurrentBasketValue();
    if (basket) {
      //  basket.shippingPrice = deliveryMethod.price;
      basket.deliveryMethodId = deliveryMethod.id;
     this.shippingPrice();
     this.setBasket(basket);
    }
  }

  getBasket(id: string) {
   
    return this.http.get<Basket>(this.baseUrl + 'basket?id=' + id).subscribe({
      next: basket => {
        this.basketSource.next(basket);
        this.calculateTotals();
      }
    })
  }
  setBasket(basket: Basket) {
    console.log(basket)
    return this.http.post<Basket>(this.baseUrl + 'basket', basket).subscribe({
      next: basket => {
        this.basketSource.next(basket);
        this.calculateTotals();
      }
    })
  }

  getCurrentBasketValue() {
    return this.basketSource.value;
  }
  addItemToBasket(item: Product | BasketItem, quantity = 1) {
    if (this.isProduct(item)) item = this.mapProductItemToBasketItem(item);
    console.log(item);
    const basket = this.getCurrentBasketValue() ?? this.createBasket();
    basket.items = this.addOrUpdateItem(basket.items, item, quantity);
    this.setBasket(basket);
  }

  removeItemFromBasket(id: number, quantity = 1) {
    const basket = this.getCurrentBasketValue();
    if (!basket) return;
    const item = basket.items.find(x => x.id === id);
    if (item) {
      item.quantity -= quantity;
      if (item.quantity === 0) {
        basket.items = basket.items.filter(x => x.id !== id);
      }
      if (basket.items.length > 0) this.setBasket(basket);
      else this.deleteBasket(basket);
    }
  }

  deleteBasket(basket: Basket) {
    return this.http.delete(this.baseUrl + 'basket?id=' + basket.id).subscribe({
      next: () => {
        this.deleteLocalBasket();
      }
    })
  }

  deleteLocalBasket() {
    this.basketSource.next(null);
    this.basketTotalSource.next(null);
    localStorage.removeItem('basket_id');
  }

  private addOrUpdateItem(items: BasketItem[], itemToAdd: BasketItem, quantity: number): BasketItem[] {
    const item = items.find(x => x.id === itemToAdd.id);
    if (item) item.quantity += quantity;
    else {
      itemToAdd.quantity = quantity;
      items.push(itemToAdd);
    }
    return items;
  }
  private createBasket(): Basket {
    const basket = new Basket();
    localStorage.setItem('basket_id', basket.id);
    return basket;
  }

  private mapProductItemToBasketItem(item: Product): BasketItem {
    return {
      id: item.id,
      productName: item.name,
      price: item.price,
      quantity: 0,
      pictureUrl: item.pictureUrl,
      brand: item.productBrand,
      type: item.productType,
      scale: item.scale,
      roastingOption: item.roastingOption,
      grindName: item.grindName
    }
  }
  private calculateTotals() {
    const basket = this.getCurrentBasketValue();
    if (!basket) return;
    const subtotal = basket.items.reduce((a, b) => (b.price * b.quantity) + a, 0);
    
    this.shippingPrice();
    const total = subtotal + basket.shippingPrice!;
    this.basketTotalSource.next({shipping: basket.shippingPrice!, total, subtotal});
  }
  private isProduct(item: Product | BasketItem): item is Product {
    return (item as Product).productBrand !== undefined;
  }
  //public updateStock(productid: number, pro: any)  {
    //return this.http.put(this.baseUrl + 'products/stockid?id=' + productid,pro)
   //}
   UpdateShipping(deliveryId: string, deliveryRequest: IDeliveryMethod) {
    const  deliveryProduct: IDeliveryToCreate = {
      shortName: deliveryRequest.shortName,
      description: deliveryRequest.description,
      price: deliveryRequest.price,
      scale: deliveryRequest.scale,
      deliveryTime: deliveryRequest.deliveryTime
    };
    return this.http.put<IDeliveryMethod>(this.baseUrl + "AdminDeliveryMethod/deliveryId?deliveryId=" + deliveryId, deliveryProduct).subscribe({
      
    })
  }
  shippingPrice() {
   // const basket = this.getCurrentBasketValue();
    // shippingPrice(); {
    const basket = this.getCurrentBasketValue()!;
    const subtotal = basket?.items.reduce((a, b) => (b.scale * b.quantity) + a, 0)!;
     if (subtotal <= 0.25)
      basket.shippingPrice = 3.00;
     else if (subtotal <= 0.50)
      basket.shippingPrice = 5.00;
     else if (subtotal <= 0.75)
      basket.shippingPrice = 7.00;
     else if (subtotal <= 1.0)
      basket.shippingPrice = 9.00
     else if (subtotal <= 1.25)
      basket.shippingPrice = 11.00
     else if (subtotal <= 1.50)
      basket.shippingPrice = 13.00;
     else if (subtotal <= 1.75)
      basket.shippingPrice = 15.00
     else if (subtotal <= 2.00)
      basket.shippingPrice = 17.00
     else if (subtotal <= 2.50)
      basket.shippingPrice = 19.00;
     else if (subtotal <= 3.00)
      basket.shippingPrice = 24.00
     else if (subtotal <= 3.50)
      basket.shippingPrice = 30.00
     else if (subtotal <= 4.00)
      basket.shippingPrice = 34.00
     else if (subtotal <= 4.50)
      basket.shippingPrice = 38.00;
     else if (subtotal <= 5.00)
      basket.shippingPrice = 42.00
     else
      basket.shippingPrice = 50.00
     
   /* const subtotal = basket.items.reduce((a, b) => (b.price * b.quantity) + a, 0);
     if (subtotal <= 19.00)
      basket.shippingPrice = 3.00;
     else if (subtotal <= 32.00)
      basket.shippingPrice = 6.00;
     else if (subtotal <= 48.00)
      basket.shippingPrice = 9.00;
    
     else
      basket.shippingPrice = 50.00*/
  }
}
